import { createReducer } from "@reduxjs/toolkit";
import { AgentTabView } from "constants/ChatViewConstants";
import { AGENT_BACKGROUND_MESSAGE_COUNT } from "actions/types";

const initialState = {
    count: 0,
};
const agentBgMsgCountReducer = createReducer(initialState, {
    [AGENT_BACKGROUND_MESSAGE_COUNT]: (state, action) => {
        state.count = action.payload;
        return state;
    },
});

export default agentBgMsgCountReducer;
